export const LOAD_QVCT_SURVEY_REPORT = 'LOAD_QVCT_SURVEY_REPORT'